module.exports = __webpack_public_path__ + "static/golden-cross-logo-2f7bff8313f699f4ae4b9efb3d3289bc.png";